import { render, staticRenderFns } from "./AddNewClient.vue?vue&type=template&id=519782fc&scoped=true"
import script from "./AddNewClient.vue?vue&type=script&lang=js"
export * from "./AddNewClient.vue?vue&type=script&lang=js"
import style0 from "./AddNewClient.vue?vue&type=style&index=0&id=519782fc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "519782fc",
  null
  
)

export default component.exports